const PROXY_CONFIG = {
  targetDomains: {
    dev: process.env.ADMIN_PORTAL_DEV_URL,
    staging: process.env.ADMIN_PORTAL_STAGING_URL,
    production: process.env.ADMIN_PORTAL_PRODUCTION_URL,
  },
  
  localhostTarget: `http://localhost:${process.env.DEV_PORT}`,
  
  getTargetForStage(stage) {
    const targetStage = stage || 'dev'
    return this.targetDomains[targetStage] || this.targetDomains.dev
  },

  transformUrlForDevelopment(url) {
    let transformedUrl = url
    
    Object.values(this.targetDomains).forEach(target => {
      transformedUrl = transformedUrl.replace(target, this.localhostTarget)
    })
    
    return transformedUrl
  },
}

module.exports = { PROXY_CONFIG } 